const checkoutBlockers = {
  none: 0,
  itemsLimitExceeded: 1,
  missingAttributes: 2,
  disabledOptionsChosen: 3,
  disabled: 4,
  disabledTheme: 5,
  deliveryOptionNotSet: 6,
  incompatibleDeliveryTypes: 7,
  noPickupLocation: 8,
  crossSellItem: 9,
  unavailableItem: 10,
  cartUpdating: 11,
  wmbAccountRestricted: 12,
  transformsNeedReview: 13,
};

const checkoutBlockerTexts = {
  [checkoutBlockers.noPickupLocation]:
    'You are unable to check out without a pick up location set.',
  [checkoutBlockers.deliveryOptionNotSet]:
    'You are unable to check out without a delivery option set.',
  [checkoutBlockers.incompatibleDeliveryTypes]:
    'You are unable to check out an order containing both Collect in Warehouse and Home Delivery products. Please select the same delivery option for all items, or remove conflicting items and purchase separately.',
  [checkoutBlockers.transformsNeedReview]:
    'One or more products were updated to match your delivery option. Please open each updated product to review it, then return to your cart before checking out.',
};

const checkoutBlockerById = (id) =>
  Object.entries(checkoutBlockers).find(([, v]) => v === id)?.[0];

export { checkoutBlockers, checkoutBlockerTexts, checkoutBlockerById };
